import type {
  CompanySelectionTypes,
  Subsidiary,
  SubsidiaryMappingWorkflow,
} from '@revelio/core';
import type { Item } from '@revelio/iso-utility';

import {
  DEFAULT_SUBSIDIARY_COLUMN_MAPPINGS,
  DEFAULT_SUBSIDIARY_SELECTED_COLUMNS,
  getSubsidiaryColumnMappings,
  useCompanyMappingStore,
} from '../company-mapping/company-mapping.store';

const getStoreActions = () => useCompanyMappingStore.getState().actions;

export const setSubsidiaryColumnMappings = (
  value: SubsidiaryMappingWorkflow
) => {
  getStoreActions().setSubsidiaryColumnMappings(value);
};
export const resetSubsidiaryColumnMappings = () => {
  getStoreActions().setSubsidiaryColumnMappings(
    DEFAULT_SUBSIDIARY_COLUMN_MAPPINGS
  );
};
export const resetSubsidiarySelectedColumns = () => {
  getStoreActions().setSubsidiarySelectedColumns(
    DEFAULT_SUBSIDIARY_SELECTED_COLUMNS
  );
};
export const updateSubsidiaryColumnMappings = (
  updater: (prevMapping: SubsidiaryMappingWorkflow) => SubsidiaryMappingWorkflow
) => {
  const current = getSubsidiaryColumnMappings();
  if (!current) {
    return;
  }
  setSubsidiaryColumnMappings(updater(current));
};
export const updateSubsidiaryMappingPrimaryCompanies = (updates: Item[]) => {
  const formatted: Subsidiary[] = updates.map((update) => {
    const primaryName = String(update.primary_name);

    return {
      title: primaryName,
      id: primaryName.split(' ').join('-'),
      company_id:
        (update.company_id as string | undefined) ?? String(update.rcid),
      hasSubsidiaries: Boolean(
        update.has_subsidiaries ?? update.hasSubsidiaries
      ),
      headCount: Number(update.raw_emp_count ?? update.headCount ?? 0),
      rcid: Number(update.rcid),
      isSelected: true,
      isIndeterminate: false,
    };
  });

  const defaultPrimaryMapping = DEFAULT_SUBSIDIARY_COLUMN_MAPPINGS.mappings
    .primary ?? {
    title: 'Primary',
    name: 'Primary',
    selectAll: true,
    isLoading: false,
    subsidiaries: [],
  };

  updateSubsidiaryColumnMappings((prevMapping) => ({
    ...prevMapping,
    mappings: {
      ...prevMapping.mappings,
      primary: {
        ...(prevMapping.mappings.primary ?? defaultPrimaryMapping),
        title:
          prevMapping.mappings.primary?.title ?? defaultPrimaryMapping.title,
        name: prevMapping.mappings.primary?.name ?? defaultPrimaryMapping.name,
        selectAll:
          prevMapping.mappings.primary?.selectAll ??
          defaultPrimaryMapping.selectAll,
        isLoading:
          prevMapping.mappings.primary?.isLoading ??
          defaultPrimaryMapping.isLoading,
        subsidiaries: formatted.sort((a, b) => b.headCount - a.headCount),
      },
    },
  }));
};

export const updateSubsidiaryMappingPreviousStep = (
  previousStep: CompanySelectionTypes
) => {
  updateSubsidiaryColumnMappings((prevMapping) => ({
    ...prevMapping,
    previousStep,
  }));
};
